export default "__VITE_ASSET__VsVsAtCO__"